// import { Tab, Tabs } from "@mui/material";
import { Costing } from "pdf-generator";
import { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../redux";
import { useLazyGetAllCostingQuery } from "../../../redux/services";
import { getUserSelectedCurrency } from "../../../utils";
import { EditSummary } from "./editSummary";
// import { PreviewSummary } from "./preview";

export const Summary: React.FC<{ readOnly: boolean, refetch: () => void }> = ({ refetch, readOnly }) => {

    const [getAllCosting, costingRes] = useLazyGetAllCostingQuery();

    const { id = "" } = useParams();

    const { pricing, auth } = useAppSelector(store => store);

    const DEFAULT_CURRENCY = getUserSelectedCurrency(auth.userPreferences).value;

    const costingData = useMemo(() => {
        const { data = [] } = costingRes;
        const latestCosting = data?.filter((d: any) => new Date(d.created_time) > new Date(pricing.modified_time));
        const mostRecentCosting: Costing = latestCosting?.reduce((recent: any, current: any) => {
            return new Date(current.created_time) > new Date(recent.created_time) ? current : recent;
        }, latestCosting[0] || {});
        const base_currency = mostRecentCosting?.pricing_config?.exchange_rates?.base_currency ?? DEFAULT_CURRENCY;
        return { costing: mostRecentCosting, hasCosting: Object.keys(mostRecentCosting).length > 0, base_currency }
        // eslint-disable-next-line
    }, [costingRes.status, pricing.modified_time, DEFAULT_CURRENCY])

    const fetchCosting = () => {
        getAllCosting({ bom_id: pricing.basic_details?.bom_id?.value as string, pricing_id: id });
    };

    useEffect(() => {
        fetchCosting();
        // eslint-disable-next-line
    }, [])

    return <EditSummary readOnly={readOnly} refetch={refetch} refetchCosting={fetchCosting} costingData={costingData} />
}